
import { Component, Vue } from "vue-property-decorator";
import { Route, RawLocation } from "vue-router";
import { API_ROUTES } from "@/utils/API";
import { API_THistory, convertHistoryForTable, THistory_Table } from "@/models/data_history";

Component.registerHooks(["beforeRouteEnter"]);

@Component({
  components: {
    Loader: () => import("@/components/Loader/Loader.vue"),
    DataHistory: () => import("@/components/DataHistory/DataHistory.vue"),
  },
})
export default class ExpertCompanyDataHistory extends Vue {
  loading = false;

  historyItems: THistory_Table[] = [];

  get companyId(): number {
    return Number(this.$route.params.company_id ?? 0);
  }

  async fetchHistory(): Promise<void> {
    if (!this.companyId) return;

    try {
      this.loading = true;

      const { data } = await this.axios.get<API_THistory[]>(
        API_ROUTES.EXPERT_COMPANIES_HISTORICAL_DATA(this.companyId)
      );

      if (!data) return;

      this.historyItems = convertHistoryForTable(data);
    } finally {
      this.loading = false;
    }
  }

  mounted() {
    this.$root.$on("update-company-level-data", this.fetchHistory);
  }

  beforeRouteEnter(
    to: Route,
    from: Route,
    next: (to?: RawLocation | ((vm: Vue) => void)) => void
  ): void {
    next((vm: any) => {
      vm.fetchHistory();
    });
  }
}
